module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea3dcbaa192a5d3412046e544d7fbf78.png";